function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "n3u6fryo3a",
  d: "M16.541 10.667c0-3.24-2.635-5.875-5.874-5.875-3.24 0-5.875 2.636-5.875 5.875s2.636 5.874 5.875 5.874 5.874-2.635 5.874-5.874m1.237 0c0 3.92-3.19 7.11-7.111 7.11s-7.111-3.19-7.111-7.11c0-3.921 3.19-7.111 7.11-7.111 3.922 0 7.112 3.19 7.112 7.11m-7.152 2.477c-.204 0-.401.084-.547.227-.144.144-.225.344-.225.546 0 .204.081.404.225.547.146.144.343.228.547.228.205 0 .404-.084.548-.228.143-.143.225-.343.225-.547 0-.202-.082-.402-.225-.546-.144-.143-.343-.227-.548-.227m2.347-5.646c.49.551.72 1.32.625 2.11-.178 1.485-1.263 2.014-2.23 2.014-.04 0-.083.001-.083.003v.375c0 .342-.277.618-.618.618-.342 0-.619-.276-.619-.618v-.498c0-.51.213-1.117 1.32-1.117.598 0 .919-.31.993-.924.024-.208.044-.735-.318-1.142-.294-.332-.77-.5-1.417-.5-1.399 0-1.439.905-1.439 1.008 0 .342-.277.618-.618.618-.342 0-.619-.276-.619-.618 0-.624.481-2.244 2.676-2.244 1.265 0 1.977.497 2.347.915"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-13 -427) translate(0 87) translate(8 335.506) translate(5.333 5.333)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "8xctoj261b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#n3u6fryo3a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#n3u6fryo3a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#8xctoj261b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H21.333V21.333H0z",
  transform: "matrix(1 0 0 -1 0 21.333)"
})))))));

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.c76a4d90.svg";
export { ForwardRef as ReactComponent };